import * as React from "react";

type InstrumentSetupSelectPortalContextValue = {
  container: HTMLElement | null;
  notifySelectOpenChange: (open: boolean) => void;
};

const InstrumentSetupSelectPortalContext =
  React.createContext<InstrumentSetupSelectPortalContextValue>({
    container: null,
    notifySelectOpenChange: () => {},
  });

export function InstrumentSetupSelectPortalProvider(props: {
  container: HTMLElement | null;
  onSelectOpenChange?: (open: boolean) => void;
  children: React.ReactNode;
}): React.ReactElement {
  const value = React.useMemo(
    () => ({
      container: props.container,
      notifySelectOpenChange: props.onSelectOpenChange ?? (() => {}),
    }),
    [props.container, props.onSelectOpenChange]
  );

  return (
    <InstrumentSetupSelectPortalContext.Provider value={value}>
      {props.children}
    </InstrumentSetupSelectPortalContext.Provider>
  );
}

export function useInstrumentSetupSelectPortal(): HTMLElement | null {
  return React.useContext(InstrumentSetupSelectPortalContext).container;
}

export function useInstrumentSetupSelectOpenNotifier(): (open: boolean) => void {
  return React.useContext(InstrumentSetupSelectPortalContext).notifySelectOpenChange;
}
